import { trackEvent } from "../../../trackEvent";

/**
 * Push any header links to datalayer when they are in the .header tag
 * Basic DOM markup assumed.
 * 
 * <div class="header">
 *  <div data-gtm-subsection="social">
 *   <button data-gtm-click>Facebook</a>
 *  </div>
 * </div>
 */

const test = ({ target }) => target.closest("[data-bv-show='rating_summary']");

const push = ({ target }) => {
    if (target.classList.contains("bv_button_buttonMinimalist")) {
        trackEvent({
            event: "click_add_review",
            event_type: "click",
            item_name: document.querySelector("[data-gtm-product='name']")?.textContent || "none"
        });
    } else if(target.classList.contains("bv_main_rating_button")) {
        trackEvent({
            event: "click_read_review",
            event_type: "click",
            item_name: document.querySelector("[data-gtm-product='name']")?.textContent || "none"
        });
    }
}

export default {
  name: "bv-rating-summary",
  test,
  push
};